export default "__VITE_ASSET__DDat6adM__"